import { useContext } from 'react'

import { AgentCentralizedContext } from '~/features/agents/constants'

const useGetAgentCentralized = () => {
  const ctx = useContext(AgentCentralizedContext)

  if (!ctx) {
    throw new Error(
      'useGetAgentCentralized must be used within a AgentCentralizedContextProvider',
    )
  }

  return ctx
}

export default useGetAgentCentralized
